<template>
    <!-- 下划线设置组件
        @author: liuguisheng
        @date: 2019-11-21
    -->
    <div class="setting-item">
    <el-form-item label="下划线长度(厘米)"> 
      <el-input-number v-model.number="underline" 
                       class="setting-render_underline"
                       controls-position="right"
                       placeholder="请输入下划线长度"></el-input-number>
    </el-form-item>
  </div>
</template>
<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 下划线
     *  @description 将 underline 字段映射到当前 underline 计算属性
     *  @return { Object }
     *  @author liuguisheng
     *  @version 2019-11-21
     */
    ...mapComputed({
      underline: { 
        parent: i => i.renderOption,
        attr: "underline"
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/render_setting/RenderUnderline.vue